<template>
  <payment-method-layout
    :value="value"
    :active="active"
    :logo-src="paymentMethodInfo.logoSrc"
    :show-inactive-chip="showControls"
    :show-delete="!active && showControls"
    @method:delete="emit('method:delete')"
    @method:set-default="emit('method:set-default')"
  >
    {{ sepaDebitInfo.number }}

    <template
      v-if="showControls && paymentMethodInfo.sepaDebitInfo.generatedFromType === ''"
      #subtitle
    >
      <v-link
        :class="[{'primary--text': active}, {'text--secondary': !active}, 'text-decoration-underline cursor-pointer']"
        @click="showPaymentMethodMandate"
      >
        {{ $t('label.payment_method_mandate') }}
      </v-link>
    </template>
  </payment-method-layout>
</template>

<script setup lang="ts">
import { PaymentMethodInfo } from '@/services/billing-utils';
import { PropType, computed } from 'vue';
import { PaymentMethod as BillingPaymentMethod } from '@/api/api-billing';
import store from '@/store/store';
import { performAction } from '@/services/vue-utils';
import i18n from '@/plugins/i18n';
import PaymentMethodLayout from './PaymentMethodLayout.vue';

const emit = defineEmits(['method:delete', 'method:set-default']);

const props = defineProps({
  value: { type: String as PropType<string>, required: true },
  active: { type: Boolean as PropType<boolean>, default: false },
  paymentMethodInfo: { type: Object as PropType<PaymentMethodInfo>, required: true },
  showControls: { type: Boolean, required: false, default: false },
});

const sepaDebitInfo = computed(() => props.paymentMethodInfo.sepaDebitInfo);

const showPaymentMethodMandate = async () => {
  const pm = props.paymentMethodInfo.paymentMethod;
  const paymentMethodID = pm.ID;
  let paymentMethod = undefined as BillingPaymentMethod|undefined;
  const action = async () => {
    paymentMethod = await store.dispatch('billingGetPaymentMethod', { paymentMethodID });
  };
  const ok = await performAction(null, i18n.tc('error.load_data'), action);
  if (!ok || !paymentMethod?.mandate?.url) return;

  const newWin = window.open(
    paymentMethod?.mandate?.url,
    'invoiceWindow',
    'height=600,width=600',
  );
  newWin!.document.close();
  newWin!.focus();
};

</script>
